import React from "react"
// import { useState } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
// import { faMoon, faSun } from '@fortawesome/free-solid-svg-icons'
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons'


export default function Top() {
  // const doc = document.documentElement
  // const [darkmode, setMode] = useState(true)
  
  // const handleMode = () => {
  //   if (darkmode) {
  //     setMode(false)
  //     doc.classList.add('light-theme');
  //   } else {
  //     setMode(true)
  //     doc.classList.remove('light-theme');
  //   }
  // }

  return (
    <div className="top">
      <div className="top-iconos">
        <a href="https://www.linkedin.com/in/crvillanueva/" aria-label="Perfil LinkedIn">
          <FontAwesomeIcon icon={ faLinkedin } />
        </a>
        <a href="https://github.com/crvillanueva" aria-label="Perfil Github">
          <FontAwesomeIcon icon={ faGithub } />
        </a>
        <a href="mailto:cristobaljvp@gmail.com" aria-label="Email">
          <FontAwesomeIcon icon={ faEnvelope } />
          <span>cristobaljvp@gmail.com</span>
        </a>
      </div>
      <div className="nombre-titulo">
        <h1>Cristóbal Villanueva</h1>
        <h2>Geólogo | Web Developer</h2>
      </div>    
      {/* <div className="toggle-mode" onClick={handleMode}>
        <FontAwesomeIcon icon={ darkmode ? faSun : faMoon }/>
      </div> */}
    </div>
  )
}